export default __webpack_public_path__ + "static/media/vision-image.5da29f13.png";